/* eslint-disable react/destructuring-assignment,react/prop-types */
// Copyright (c) 2019 Deere & Company

import './index.scss';
import React, {
    Component,
} from 'react';
import AccordionHeader from './header';

class Accordion extends Component {

    state = {
        isExpanded: this.props.isExpanded,
    };

    componentWillReceiveProps(nextProps) {

        if (this.props.isExpanded !== nextProps.isExpanded) {

            this.setState({
                isExpanded: nextProps.isExpanded,
            });

        }

    }

    handleClick = () => {

        this.setState({
            isExpanded: !this.state.isExpanded,
        });

        if (this.props.onClick) {

            this.props.onClick(!this.state.isExpanded);

        }

    };

    render = () => {

        const isOpenClassName = this.state.isExpanded ?
            'is-open' :
            'is-closed';

        const accordionClassName = `accordion ${this.props.accordionId} ${isOpenClassName}`;

        return (
            <section className={accordionClassName}>
                <AccordionHeader
                    isExpanded={this.state.isExpanded}
                    onClick={this.handleClick}
                    secondaryNode={this.props.secondaryHeaderNode}
                    title={this.props.title}
                    addAccordianContents={this.props.addAccordianContents}
                    updateSequenceContents={this.props.updateSequenceContents}
                    handleaddAccordianContent={this.props.handleAddAccordinanContent}
                    handleupdateSequenceContent={this.props.handleupdateSequenceContent}
                />
                {this.state.isExpanded && <div className="accordion-body">{this.props.body}</div>}
            </section>

        );

    }

}

Accordion.displayName = 'Accordion';

Accordion.defaultProps = {
    isExpanded: false,
};

export default Accordion;
